import { render } from "./BarChart-horizontal-stacked.vue?vue&type=template&id=71cd207c"
import script from "./BarChart-horizontal-stacked.vue?vue&type=script&lang=js"
export * from "./BarChart-horizontal-stacked.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__